module.exports = __webpack_public_path__ + "img/MOTphone1.00e79ade.png";